import React from "react";
import { ComingSoonImg } from "../../assets/images";

const OnTimeArrival = () => {
  return (
    <div className="boxs m-0 w-100 p-4" style={{ height: "207px" }}>
      <div className="d-flex justify-content-between">
        <span className="boxs-container-heading">On Time Arrival</span>
      </div>
      <div className="mt-3 d-flex justify-content-center">
        <img src={ComingSoonImg} alt="coming-soon" />
      </div>
    </div>
  );
};

export default OnTimeArrival;
